export const VALIDATE_EMAIL = gql`
    mutation validateEmailAddress($email: String!) {
        validateEmailAddress(email: $email) {
            responseCode
            responseMessage
        }
    }
`;

export const VALIDATE_PHONE_NUMBER = gql`
    mutation validatePhoneNumber($phoneNumber: String!) {
        validatePhoneNumber(phoneNumber: $phoneNumber) {
            isValid
            phoneNumber
        }
    }
`;
